<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <ChatNavbar :title="'test'" :user="selectedUser" @back-button="onBackButton" />
      <div class="d-flex flex-column justify-space-between chat-content">
        <div id="chat-content" class="py-xs messages-content">
          <MessagesChat />
        </div>

        <div v-if="bookingSelected && bookingSelected.status === 'accepted'" class="px-xs">
          <InputChat :booking-id="bookingSelected.id" :socket="socket" :user="selectedUser" />
        </div>
        <div
          v-else-if="bookingSelected && bookingSelected.status !== 'accepted'"
          class="d-flex w-100 justify-space-center"
        >
          <p class="text-color-placeholder bold-medium">{{ t('support.notAvailable') }}</p>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
  import { IonPage, IonContent } from '@ionic/vue';
  import { useBookingStore } from '@/stores/booking-store';
  import router from '@/router';
  import { notificationServiceInit } from '@/services/FirebasePushNotifications';
  import ChatNavbar from '@/components/support/ChatNavbar.vue';
  import { useRoute } from 'vue-router';
  import { ref, watch, onMounted } from 'vue';
  import Botgerin from '@/assets/images/botgerin.png';
  import InputChat from '@/components/support/InputChat.vue';
  import MessagesChat from '@/components/support/MessagesChat.vue';
  import { initSocket } from '@/services/socket';
  import { storeToRefs } from 'pinia';
  import { useChatStore } from '@/stores/chat-store';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const { state, connectSocket } = initSocket();
  const { page, socket } = storeToRefs(useChatStore());
  const { resetStore } = useChatStore();

  const route = useRoute();
  const selectedUser = ref();
  const bookingSelected = ref();

  const onBackButton = async () => {
    await clearChat();
    router.back();
  };

  const clearChat = () => {
    resetStore();
    if (route.query.user === 'owner') {
      leftChat();
    }
  };

  const leftChat = () => {
    state.connected = false;
    if (socket.value && bookingSelected.value) {
      socket.value.emit('f_leave_chat_room', bookingSelected.value.id);
    }
  };

  const sendEmit = () => {
    if (state.connected && bookingSelected.value) {
      socket.value.emit('f_enter_chat_room', bookingSelected.value.id);
    } else {
      setTimeout(() => {
        sendEmit();
      }, 500);
    }
  };

  const sendEmitLoadMoreMessages = () => {
    socket.value.emit('f_load_more_messages', {
      reservationId: bookingSelected.value.id,
      page: page.value + 1,
    });
  };

  const checkQuery = () => {
    selectedUser.value =
      route.query.user === 'owner'
        ? (selectedUser.value = bookingSelected.value?.Owner)
        : {
            fullName: 'Botgerin',
            photo: Botgerin,
          };
  };

  const handleGetBooking = async (bookingId: string) => {
    const { getBooking } = useBookingStore();

    try {
      const response = await getBooking(bookingId);
      if (response.id && response.RentalUnit) {
        bookingSelected.value = response;
        checkQuery();
      }
    } catch (error) {
      console.log('not booked', error);
    }
  };

  const setListenerWindowScroll = () => {
    const myTarget = document.getElementById('chat-content');

    if (myTarget) {
      myTarget.addEventListener('scroll', function () {
        if (myTarget.scrollTop === 0) {
          sendEmitLoadMoreMessages();
        }
      });
    }
  };

  const initialConfig = async () => {
    clearChat();
    if (route.query.user === 'owner') {
      connectSocket();
      notificationServiceInit();
      await handleGetBooking(route.params.bookingId as string);
      setListenerWindowScroll();
    } else {
      checkQuery();
    }
  };

  onMounted(() => {
    initialConfig();
  });

  watch(state, () => {
    if (state.connected && route.query.user === 'owner') {
      sendEmit();
    }
  });

  watch(route, () => {
    if (route.params.bookingId) {
      initialConfig();
    }
  });
</script>

<style lang="css" scoped>
  .chat-content {
    height: 91vh;
    scroll-behavior: smooth;
  }
  .messages-content {
    height: 85vh;
    overflow-y: auto;
    scroll-behavior: smooth;
  }
</style>
